import React from 'react';
import AppVars from '../../AppVars.js';
import CreatePassword from '../Register/Local/CreatePasswordForm.js';
import VerifyCode from '../Code/VerifyCode.js';
import Loader from '../Loader.js';
import { getCallbacks } from 'account-portal-library/lib/emailSignIn';
import axios from 'axios';

const appVars = AppVars.getInstance();

const UNKNOWN_ERROR_URL = "/unknownerror";
const INPUT_TYPES = {
    "PHONE": "^(?!0)[0-9]{10}$",
    "EMAIL": "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)"
}

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            payload: null,
            code: null,
            username: null,
            signInType: null,
            isResponseValid: false,
            showForm: "RESET",
        };
        this.displayForm = this.displayForm.bind(this);
        this.savePayload = this.savePayload.bind(this);
        this.saveCode = this.saveCode.bind(this);
        this.sendJourneyPayload = this.sendJourneyPayload.bind(this);
    }

    async sendJourneyPayload(journeyPayload, url, headers, params) {
        try {
            const resp = await axios({ method: 'post', url, headers, params, data: journeyPayload });
            return {
                response: resp.data,
                status: resp.status
            };
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            return {
                response: data,
                status: status,
                failureUrl: status === 401 ? data?.failureUrl || UNKNOWN_ERROR_URL : UNKNOWN_ERROR_URL
            };
        }
    };

    async startJourney() {
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getResetPasswordTree()
            };
            const headers = {
                'Accept-API-Version': 'resource=1.1',
                'Content-Type': 'application/json',
                'x-username': sessionStorage.AP_SSID,
            };
            console.log("Password Reset Journey Started");
            const journeyStart = await getCallbacks(url, headers, params);
            if (journeyStart.status !== 200) {
                throw journeyStart.response;
            }
            this.setState({ payload: journeyStart.response, isResponseValid: true });
        } catch (errorResponse) {
            console.log("Error -> ", errorResponse);
            this.setState({ isResponseValid: false });
            window.location.replace(errorResponse.failureUrl || UNKNOWN_ERROR_URL);
        }
    }

    componentDidMount() {
        if (!sessionStorage.AP_SSID) {
            window.location.replace("/");
        }

        this.startJourney();
    }

    checkUsernameType(username) {
        var TYPE = null;
        for (const key in INPUT_TYPES) {
            if (username.match(INPUT_TYPES[key]) && appVars.getIncludeSignIn(key)) {
                TYPE = key;
            }
        }
        return TYPE;
    }

    saveCode(value) {
        this.setState({ code: value })
    }

    savePayload(value) {
        this.setState({ payload: value });
    }

    displayForm(value) {
        this.setState({ showForm: value });
    }

    render() {
        if (this.state.isResponseValid === false)
            return (<Loader />)

        return (
            <>
                {this.state.showForm === "RESET" &&
                    <VerifyCode
                        style={sessionStorage.AP_STYLE}
                        payload={this.state.payload}
                        showForm={this.state.showForm}
                        signInType={this.checkUsernameType(sessionStorage.AP_SSID)}
                        savePayload={this.savePayload}
                        saveCode={this.saveCode}
                        displayForm={this.displayForm}
                    />
                }
                {this.state.showForm === "PASSWORD" &&
                    <CreatePassword
                        style={sessionStorage.AP_STYLE}
                        signInType={this.checkUsernameType(sessionStorage.AP_SSID)}
                        payload={this.state.payload}
                        code={this.state.code}
                        displayForm={this.displayForm}
                        prevStep="RESET"
                    />
                }
            </>
        )
    }
}

export default ResetPassword;